/** A desk rating, a like receipt, or a publish receipt. The room shows none of them as a comment. */
export function isDeskReceipt(body: string): boolean {
  const text = body.trim();
  return (
    text.startsWith("desk-star:") ||
    text.startsWith("desk-published:") ||
    text.startsWith("desk-like:")
  );
}
